"use strict";

exports.__esModule = true;
exports.SandvikWrapper = SandvikWrapper;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _base = _interopRequireDefault(require("../base"));
var _hangingLogo = _interopRequireDefault(require("../../../assets/sandvik/hanging-logo.png"));
var _background = _interopRequireDefault(require("../../../assets/sandvik/background.jpg"));
var _global = require("./global");
var _TooltipGlobals = require("../TooltipGlobals");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var HangingLogo = _styledComponents["default"].img.withConfig({
  displayName: "SandvikWrapper__HangingLogo",
  componentId: "sc-j2r0zj-0"
})(["z-index:20;position:absolute;right:20px;top:0;height:82px;width:82px;"]);
var SandvikThemeWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SandvikWrapper__SandvikThemeWrapper",
  componentId: "sc-j2r0zj-1"
})(["flex:1;.", " & .", ",.", ".", "{box-shadow:none;border-bottom:solid 1px #aaaaaa;}.AppHomeScreen .AppHomeScreen_Container{background-image:url(", ");background-repeat:none;background-size:cover;}.settings-menu-container{right:140px;}div.rt-noData{color:", ";background:", ";}"], _core.Classes.DARK, _core.Classes.NAVBAR, _core.Classes.NAVBAR, _core.Classes.DARK, _background["default"], _base["default"].DataTableMessageColor, _base["default"].DataTableMessageBackground);
function SandvikWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(SandvikThemeWrapper, null, /*#__PURE__*/_react["default"].createElement(_global.SandvikGlobal, null), /*#__PURE__*/_react["default"].createElement(_TooltipGlobals.TooltipGlobals, null), /*#__PURE__*/_react["default"].createElement(HangingLogo, {
    src: _hangingLogo["default"]
  }), children);
}